import { isNullOrEmpty } from '../config/ENV';
export function showLocalDateTime(notecreatedOn){
    let timeZone = new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' })
    .formatToParts(new Date())
    .find(part => part.type == "timeZoneName")
    .value
    var moment = require('moment-timezone');
    var date = new Date(notecreatedOn);
      date.toString();
      const tempArr = date.toString().split(" ")
      var amOrPm = "";
      const dateArr = date.toLocaleString().split(" ");
      const timeArr = dateArr[1].split(":");

    //   const timeArr=tempArr[4].split(":");

      if (!isNullOrEmpty(dateArr[2])) {
        amOrPm = dateArr[2];
      }
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return (
        months[date.getMonth()] +
        " " +
        date.getDate() +
        ", " +
        " " +
        date.getFullYear() +
        " " +
        timeArr[0] +
        ":" +
        timeArr[1] +
        " " +
        amOrPm +
        " " + 
        moment.tz(moment.tz.guess()).zoneAbbr()
  
      );

}